/**
 * const.js(設定値管理)
 */
'use strict';

let env = typeof process.env.NODE_ENV === 'undefined' ? 'development' : process.env.NODE_ENV;

// -------------------------------------------------------


// プロジェクトステータス
let project_status = [
  { id: 'recovery',               name: 'リカバリー案件',                  help: '' },
  { id: 'preparing',              name: '準備中',                          help: '' },
  { id: 'on_offer',               name: 'オファー中',                      help: '' },
  { id: 'appointment_confirmed',  name: '起用者確定（発送・来店待ち）',    help: '' },
  { id: 'submitting_draft',       name: '下書き提出中',                    help: '' },
  { id: 'draft_submitted',        name: '下書き初稿提出完了',              help: '' },
  { id: 'submission_completed',   name: '投稿完了（インサイト提出待ち）',  help: '' },
  { id: 'insight_completed',      name: 'インサイト提出完了',              help: '' },
  { id: 'complete',               name: '完了',                            help: '' },
];

/*
 * 定数設定
 */
const value = {
  // サイト名
  domain            : 'https://space.moribus.jp/',
  site_name         : 'CASTING SPACE',
  request_timeout   : (1000 * 60 * 2),
  
  // デバイスサイズ
  device : {
    tablet     : 768,         // タブレット画面サイズ
    smartphone : 568,         // スマートフォン画面サイズ
  },
  
  // クッキー
  cookie : {
    path    : '/',                   // クッキーパス
    expired : (1000 * 60 * 60 * 24 * 30), // 有効期限（30日）
  },
  
  // トークン
  // ※ シークレットはこのファイルに置かない（server/config/const.js はクライアントの
  //    webpackバンドルにも含まれるため）。実体は server/config/secrets.js を参照。
  token : {
    expired : '30d',      // クレデンシャルトークン有効期限
  },
  
  // ワークリスト 
  schedule_works : {
    'assign'             : { name: '候補者調査・アサイン', color: '#f0b354', icon: 'edit' },
    'draft'              : { name: '下書き確認',           color: '#f0b354', icon: 'edit' },
    'client_check'       : { name: 'クライアント確認',     color: '#93bfeb', icon: 'edit' },
    'post'               : { name: '投稿期間',             color: '#93bfeb', icon: 'image' },
    'insight_submission' : { name: 'インサイト提出',       color: '#93bfeb', icon: 'edit' },
  },
  
  // ワークリスト
  schedule_workflow : {
    'posting_date'       : { name: '投稿日',         color: '#f0b354', icon: 'edit' },
    'insight_submission' : { name: 'インサイト提出', color: '#93bfeb', icon: 'edit' },
  },
  
  // 管理者権限コード
  authority : {
    'GUEST' : '0',
    'USER'  : '1',
    'ADMIN' : '99',
  },
  
  // 管理者権限リスト
  authorityArray : [
    { id: 1,  name: '一般ユーザー' },
    { id: 99, name: '管理者' },
  ],
  
  // 投稿種別
  contents_type : {
    'FEED'   : 'フィード',
    'REELS'  : 'リール',
    'STORY'  : 'ストーリー',
    'TIKTOK' : 'TikTok',
    'X'      : 'x(twitter)',
  },
  contents_type_list : [
    { id: 'FEED',    name: 'フィード',   caption: true,  report: true, },
    { id: 'REELS',   name: 'リール',     caption: true,  report: true, },
    { id: 'STORY',   name: 'ストーリー', caption: false, report: true, },
    { id: 'TIKTOK',  name: 'TikTok',     caption: true,  report: true, },
    { id: 'X',       name: 'x(twitter)', caption: true,  report: true, },
  ],
  
  // ワークフロー
  workflow : [
    { id: 'stock',               name: 'ストック',                   order: 1,  color: 'yellow', group: 'candidate', image: 'search',       help: '内部で保留するためのアカウント' },
    { id: 'candidate',           name: '候補者',                     order: 2,  color: 'yellow', group: 'candidate', image: 'search',       help: '選定作業前のアカウント' },
    { id: 'client_check',        name: 'クライアント確認',           order: 3,  color: 'yellow', group: 'candidate', image: 'client_check', help: 'クライアントが確認するアカウント' },
    { id: 'assign_target',       name: '案件案内（DM未送信）',       order: 4,  color: 'yellow', group: 'candidate', image: 'client_check', help: 'クライアントが承認したアカウント' },
    { id: 'assign_target_dm_ok', name: '初回DM送付済み',             order: 5,  color: 'yellow', group: 'candidate', image: 'client_check', help: 'DM送信済みで連絡待ち状態のアカウント' },
    { id: 'assign_action',       name: 'アサインアクション',         order: 6,  color: 'green',  group: 'assign',    image: 'assign',       help: 'DM送信・システム連携・契約確認' },
    { id: 'assign_complete',     name: 'エントリー済み',             order: 7,  color: 'green',  group: 'assign',    image: 'complete',     help: 'アサインが完了したアカウント' },
    { id: 'draft',               name: '下書き',                     order: 8,  color: 'blue',   group: 'execution', image: 'draft',        help: '投稿の下書き中のアカウント' },
    { id: 'waiting_post',        name: '投稿待機',                   order: 9,  color: 'blue',   group: 'execution', image: 'complete',     help: '下書き確認が完了して、投稿待ちのアカウント' },
    { id: 'insight_check',       name: 'インサイト提出',             order: 10, color: 'blue',   group: 'execution', image: 'insight',      help: '投稿が完了して、インサイトの提出待ちのアカウント' },
    { id: 'claim',               name: '請求',                       order: 11, color: 'blue',   group: 'execution', image: 'claim',        help: '請求処理中のアカウント' },
    { id: 'complete',            name: '完了',                       order: 12, color: 'blue',   group: 'execution', image: 'complete',     help: '投稿・請求が完了したアカウント' },
  ],
  
  // プロジェクトステータス
  project_status : project_status,
  
  // プロジェクトステータス
  project_edit_columns :{
    title: [
      { id: 'title',                name: 'プロジェクト名',                 mode: 'text',          is_required: true,  default: '',  fmt: '',    after: '',   help: 'プロジェクトのタイトルになります。このタイトルはインフルエンサーには表示されません', sub_title: '商用プロジェクトは「クライアント名_サービス名_その他（投稿月等）」の形でプロジェクト名設定してください' },
      { id: 'project_status',       name: 'ステータス',                     mode: 'select',        is_required: false, default: 'preparing',  fmt: '',    after: '',   help: '', list: project_status.concat() },
      { id: 'order_number',         name: '発注書番号',                     mode: 'text',          is_required: false, default: '',  fmt: 'str', after: '',   help: '' },
      { id: 'order_detail',         name: '受注内容',                       mode: 'textarea',      is_required: false, default: '',  fmt: 'str', after: '',   help: '' },
      { id: 'cost',                 name: '受注金額',                       mode: 'num',           is_required: false, default: '',  fmt: 'num', after: '円', help: '' },
      { id: 'is_production',        name: '商用環境',                       mode: 'checkbox',      is_required: false, default: 0,   fmt: '',    after: '',   help: '商用に設定すると、ダッシュボードの一覧で表示の管理を行えます。', checkbox_name: '商用のプロジェクトに設定する' },
      { id: 'slack_bot_channel',    name: 'スラックの通知チャンネル',       mode: 'custom_items',  is_required: false, default: 0,   fmt: '',    after: '',   help: '' },
    ],
    detail: [
      { id: 'open_title',           name: 'プロジェクト名 (公開)',          mode: 'text',          is_required: false, default: '',  fmt: '',    after: '',   help: 'プロジェクトのタイトルになります。インフルエンサーに表示されるので簡潔な名称にしましょう。' },
      { id: 'main_detail',          name: 'プロジェクト詳細',               mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'short_detail',         name: 'プロジェクト概要',               mode: 'text',          is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'thumbnail',            name: 'プロジェクト画像（サムネイル）', mode: 'image',         is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'post_contents',        name: '投稿種別',                       mode: 'post_contents', is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'post_guide_url',       name: '投稿指示書URL',                  mode: 'text',          is_required: false, default: '',  fmt: 'url', after: '',   help: '' },
      { id: 'business_contents',    name: '本件業務の内容',                 mode: 'text',          is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'project_start_date',   name: '本件業務の期間',                 mode: 'date',          is_required: false, default: '',  fmt: '',    after: '',   help: '入力した期間が業務開始日で、終了日はその6ヶ月後に自動で設定されます。' },
      { id: 'must_hashtag',         name: '必須ハッシュタグ',               mode: 'tags',          is_required: false, default: '',  fmt: '',    after: '',   help: '投稿のテキストに必ず入力する必要のあるハッシュタグを設定できます。登録することで下書きの確認コストを削減させる効果があります。' },
      { id: 'must_keyword',         name: '必須キーワード',                 mode: 'tags',          is_required: false, default: '',  fmt: '',    after: '',   help: '投稿のテキストに必ず入力する必要のあるキーワードを設定できます。登録することで下書きの確認コストを削減させる効果があります。' },
      { id: 'insight_wait_date',    name: 'インサイトデータ提出までの日数', mode: 'num',           is_required: false, default: '7', fmt: '',    after: '',   help: '投稿をしてからインサイトデータを提出するまでの期間を設定しましょう。該当の日数が経過するとインフルエンサーに対して、インサイト提出の依頼を自動でリマインドします。' },
      { id: 'custom_urls',          name: '共有リンクリスト',               mode: 'custom_urls',   is_required: false, default: '',  fmt: '',    after: '',   help: '' },
    ],
    dm: [
      { id: 'main_dm_account',            name: 'メイン送信用アカウント',                           mode: 'dm_accounts',   is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'invitation_message',         name: '初回メッセージ',                                   mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '', template: '' },
      { id: 'assign_message',             name: 'アサイン依頼DMメッセージ（未連携）',               mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '', template: '' },
      { id: 'registered_message',         name: 'アサイン依頼DMメッセージ（連携済み）',             mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '', template: '' },
      { id: 'insight_message',            name: 'インサイト提出のリマインドメッセージ（未連携）',   mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '', template: '' },
      { id: 'registered_insight_message', name: 'インサイト提出のリマインドメッセージ（連携済み）', mode: 'textarea',      is_required: false, default: '',  fmt: '',    after: '',   help: '', template: '' },
    ],
    schedule: [
      { id: 'schedule',             name: '',               mode: 'schedule',      is_required: false, default: '',  fmt: '',    after: '',   help: '', base_list: [
        { id: 'assign',             name: '候補者調査・アサイン期間' },
        { id: 'draft',              name: '下書き期間' },
        { id: 'client_check',       name: 'クライアント確認' },
        { id: 'post',               name: '投稿期間'   },
        { id: 'insight_submission', name: 'インサイト提出期間' },
      ] },
    ],
    management: [
      { id: 'management_admin',     name: '管理者',                         mode: 'management',    is_required: true,  default: '',  fmt: '',    after: '',   help: 'ワークフローの運用や各種データを変更できるユーザーを設定しましょう。' },
      { id: 'management_worker',    name: '作業担当者',                     mode: 'management',    is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'is_private',           name: 'プロジェクトの公開',             mode: 'checkbox',      is_required: false, default: 0,   fmt: '',    after: '',   help: 'プライベート状態にすると、管理者・作業者のみ閲覧が可能になります。', checkbox_name: '管理者・作業者のみに制限する' },
      { id: 'management_company',   name: 'ゲスト会社設定',                 mode: 'management',    is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'management_guest',     name: 'ゲストユーザー設定',             mode: 'management',    is_required: false, default: '',  fmt: '',    after: '',   help: '' },
      { id: 'draft_flow_template',  name: '下書きの確認順（テンプレート）', mode: 'draft_flow',    is_required: false, default: '',  fmt: '',    after: '',   help: '' },
    ]
  },
  
  // インサイトスコア
  insight_score : {
    'likes'              : 'いいね',
    'comments'           : 'コメント数',
    'dm_message'         : 'DM返信数',
    'saved'              : '保存数',
    'reach'              : 'シェア数',
    'impressions'        : 'インプレッション',
    'share'              : 'シェア数',
    'plays'              : '再生数',
    'first_plays'        : '初回の再生',
    'replay'             : 'リプレイ',
    'score_home'         : 'IMP(ホーム)',
    'score_profile'      : 'IMP(プロフィール)',
    'score_tag'          : 'IMP(ハッシュタグ)',
    'score_etc'          : 'IMP(その他)',
    'score_discovery'    : 'IMP(発見)',
    'profile_active'     : 'アクティビティ',
    'profile_exlink'     : '外部リンク',
    'profile_access'     : 'プロフィールへのアクセス',
    'profile_follow'     : 'フォロー数',
    'link_clicks'        : 'リンクのクリック',
    'total_action'       : '実行されたアクション',
    'reach'              : 'リーチ',
    'action_account'     : 'アクション',
    'action_profile'     : 'プロフィール',
    'action_interaction' : 'インタラクション', 
  },
  
  // シートのカスタマイズ（デフォルト）
  sheet_default: {
    header : [
      { id: 'insta_id',   name: 'インスタグラムID' },
      { id: 'full_name',  name: '名前' },
      { id: 'url',        name: 'URL' },
      { id: 'followers',  name: 'フォロワー数' },
      { id: 'engagement', name: 'エンゲージメント率' },
    ],
    custom: {},
  },
  
  // カテゴリーリスト
  categoryMst: [
    { id:  7, order:  1, name: '美容・メイク・コスメ',               },
    { id:  6, order:  2, name: 'ファッション',                       },
    { id:  3, order:  3, name: 'アクセサリー / ジュエリー',          },
    { id:  5, order:  4, name: 'グルメ /  美食',                     },
    { id:  2, order:  5, name: '料理 / お菓子作り',                  },
    { id:  1, order:  6, name: 'レストラン / カフェ',                },
    { id:  4, order:  7, name: '旅行 / 観光',                        },
    { id: 33, order:  8, name: 'ファミリー / カップル',              },
    { id:  9, order:  9, name: 'ママ / 子育て',                      },
    { id: 10, order: 10, name: 'スポーツ',                           },
    { id: 15, order: 11, name: '観戦',                               },
    { id: 12, order: 12, name: 'トレーニング / フィットネス/ ヨガ',  },
    { id: 19, order: 13, name: 'ダイエット',                         },
    { id: 14, order: 14, name: '健康',                               },
    { id: 18, order: 15, name: '音楽',                               },
    { id: 17, order: 16, name: '映画',                               },
    { id: 11, order: 17, name: 'エンターティメント',                 },
    { id: 20, order: 18, name: 'ライブ / イベント',                  },
    { id: 21, order: 19, name: '芸能 / アイドル',                    },
    { id:  8, order: 20, name: 'ペット / 動物',                      },
    { id: 13, order: 21, name: '家具 / インテリア / 雑貨',           },
    { id: 22, order: 22, name: '家電',                               },
    { id: 23, order: 23, name: '読書',                               },
    { id: 24, order: 24, name: 'マンガ / アニメ / イラスト',         },
    { id: 25, order: 25, name: 'ゲーム',                             },
    { id: 26, order: 26, name: 'コンピューター / ガジェット',        },
    { id: 27, order: 27, name: 'インターネット  / アプリ',           },
    { id: 28, order: 28, name: '自然 /花 / ガーデニング ',           },
    { id: 29, order: 29, name: 'カメラ / 写真',                      },
    { id: 30, order: 30, name: 'DIY / 日曜大工',                     },
    { id: 31, order: 31, name: 'アウトドア',                         },
    { id: 32, order: 32, name: '車 / バイク',                        },
    { id: 16, order: 33, name: 'アート / デザイン / 建築',           },
    { id: 34, order: 34, name: '教育',                               },
    { id: 35, order: 35, name: 'ビジネス / キャリア',                },
    { id: 36, order: 36, name: '金融 / 経済',                        },
    { id: 37, order: 37, name: '語学',                               },
    { id: 38, order: 38, name: '恋愛',                               },
    { id: 39, order: 39, name: 'ラグジュアリー/ハイブランド',        },
    { id: 40, order: 40, name: 'ギャンブル',                         },
  ],
  
  // レポートカラムリスト
  reportMst: [
    { id: 'score_basic',   name: 'フィード・リール・TikTok' },
    { id: 'score_reach',   name: 'フィード・リール(リーチ)' },
    { id: 'score_feed',    name: 'フィード'                 },
    { id: 'score_reel',    name: 'リール'                   },
  ],
  
  // レポートカラムリスト
  reportColumns: [
    { id: 'followers',             name: 'フォロワー数',               parent: 'score_basic',  type: 'viewInt', product_types: ['FEED', 'REELS', 'TIKTOK'], className: 'text-right',   width: 100 },
    { id: 'likes',                 name: 'いいね数',                   parent: 'score_basic',  type: 'viewInt', product_types: ['FEED', 'REELS', 'TIKTOK'], className: 'text-right',   width: 100 },
    { id: 'comments',              name: 'コメント数',                 parent: 'score_basic',  type: 'viewInt', product_types: ['FEED', 'REELS', 'TIKTOK'], className: 'text-right',   width: 100 },
//    { id: 'share',                 name: 'シェア',                     parent: 'score_basic',  type: 'viewInt', product_types: ['FEED', 'REELS', 'TIKTOK'], className: 'text-right',   width: 100 },
    { id: 'saved',                 name: '保存',                       parent: 'score_basic',  type: 'viewInt', product_types: ['FEED', 'REELS', 'TIKTOK'], className: 'text-right',   width: 100 },
    { id: 'reach',                 name: 'リーチ',                     parent: 'score_reach',  type: 'viewInt', product_types: ['FEED', 'REELS'],           className: 'text-right',   width: 100 },
    { id: 'followers_in',          name: 'フォロワー（％）',           parent: 'score_reach',  type: 'viewPer', product_types: ['FEED', 'REELS'],           className: 'text-right',   width: 125 },
    { id: 'followers_not',         name: 'フォロワー外（％）',         parent: 'score_reach',  type: 'viewPer', product_types: ['FEED', 'REELS'],           className: 'text-right',   width: 125 },
    { id: 'impressions',           name: '閲覧数',                     parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 125 },
    { id: 'score_home',            name: 'ホーム',                     parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 100 },
    { id: 'score_discovery',       name: '発見',                       parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 100 },
    { id: 'score_profile',         name: 'プロフィール',               parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 100 },
//    { id: 'score_tag',             name: 'ハッシュタグ',               parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 100 },
    { id: 'score_etc',             name: 'その他',                     parent: 'score_feed',   type: 'viewInt', product_types: ['FEED'],                    className: 'text-right',   width: 100 },
    { id: 'reel_profile',          name: 'プロフィール（％）',         parent: 'score_reel',   type: 'viewPer', product_types: ['REELS'],                   className: 'text-right',   width: 100 },
    { id: 'reel_feed',             name: 'フィード（％）',             parent: 'score_reel',   type: 'viewPer', product_types: ['REELS'],                   className: 'text-right',   width: 100 },
    { id: 'reel_recommend',        name: 'おすすめ（％）',             parent: 'score_reel',   type: 'viewPer', product_types: ['REELS'],                   className: 'text-right',   width: 100 },
    { id: 'reel_etc',              name: 'その他（％）',               parent: 'score_reel',   type: 'viewPer', product_types: ['REELS'],                   className: 'text-right',   width: 100 },
    { id: 'plays_time_avg',        name: '平均再生時間',               parent: 'score_reel',   type: 'viewInt', product_types: ['REELS'],                   className: 'text-right',   width: 100 },
  ],
  
}
// -------------------------------------------------------

module.exports = {
  value,
};
